import { gql } from '@apollo/client'

import { MENU_CURATION_TASK_LIST_FRAGMENT } from '../../../menu-curation-tasks/graphql/fragments'

const PRIORITY_TASK_MENU_CURATION_TASKS = gql`
  query priorityTaskMenuCurationTasks(
    $filters: PriorityTaskMenuCurationTasksFiltersInput!
    $pagination: PaginationInput!
  ) {
    priorityTaskMenuCurationTasks(filters: $filters, pagination: $pagination) {
      total
      result {
        ...MenuCurationTaskListFragment
      }
    }
  }
  ${MENU_CURATION_TASK_LIST_FRAGMENT}
`

export default PRIORITY_TASK_MENU_CURATION_TASKS
